import type { AppDispatch, AppStore, RootState } from "@/redux/store";
import { useDispatch, useSelector, useStore } from "@repo/redux-toolkit";

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
export const useAppStore = useStore.withTypes<AppStore>();
